import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { prevMonth, nextMonth } from "../store/mainStore";
import AccountBox from "../components/AccountBox";
import { useQuery } from "react-query";
import { getTypes } from "../api/budget";
import { getAccount } from "../api/account";
import queryClient from "../utils/query";

export default function AccountBook() {
  const dateStore = useSelector((state) => state.date);
  const mainStore = useSelector((state) => state.main);
  const [state, setState] = useState({
    items: JSON.parse(localStorage.getItem("accounts")),
    types: [],
    loading: false,
  });

  const dispatch = useDispatch();
  const { data } = useQuery({
    queryKey: ["getAccount", dateStore.year, dateStore.month],
    queryFn: async () => await getAccount(dateStore.year, dateStore.month),
    enabled: !!dateStore.year && !!dateStore.month,
  });

  const typeList = useQuery({
    queryKey: "getTypes",
    queryFn: async () => await getTypes(),
  }).data;

  const startDate = `${dateStore.year}-${dateStore.month.toLocaleString(
    "en-US",
    {
      minimumIntegerDigits: 2,
      useGrouping: false,
    }
  )}-17`;
  const endDate = `${dateStore.year}-${(dateStore.month + 1).toLocaleString(
    "en-US",
    {
      minimumIntegerDigits: 2,
      useGrouping: false,
    }
  )}-16`;

  useEffect(() => {
    async function loadData() {
      await queryClient.invalidateQueries([
        "getAccount",
        dateStore.year,
        dateStore.month,
      ]);
    }
    loadData();
  }, [dateStore.year, dateStore.month]);

  const getIncome = () => {
    if (!data || data.length === 0) return 0;
    const incomeList = data.filter((t) => t.TYPE === 5);
    if (incomeList.length === 0) return 0;

    return incomeList.reduce((accumulator, obj) => {
      return accumulator + obj.AMOUNT;
    }, 0);
  };

  const getOutcome = () => {
    if (!data || !data.length === 0) return 0;
    return data
      .filter((t) => t.TYPE < 5)
      .reduce((accumulator, obj) => {
        return accumulator + obj.AMOUNT;
      }, 0);
  };

  const convertCurrency = (number) => {
    return new Intl.NumberFormat().format(number);
  };

  let accountEl = [];
  if (typeList && typeList.length > 0) {
    accountEl.push(
      <AccountBox
        type={5}
        list={data?.filter((t) => t.TYPE === 5)}
        edit={true}
        titleClassName="bg-sky-100"
        title="수입"
      />
    );

    for (var i = 1; i <= 4; i++) {
      accountEl.push(
        <AccountBox
          type={i}
          list={data?.filter((t) => t.TYPE === i)}
          edit={true}
          title={typeList[i - 1].NAME}
          income={getIncome()}
        />
      );
    }
  } else {
    accountEl.push(<div key="none">None</div>);
  }

  return (
    <section>
      <div>
        <span
          className="button mr-2 rounded"
          onClick={() => dispatch(prevMonth())}
        >
          ◀
        </span>
        {startDate}~{endDate} 통장생활
        <span
          className="button ml-2 rounded"
          onClick={() => dispatch(nextMonth())}
        >
          ▶
        </span>
      </div>
      <div className="text-gray-400 border-t border-b border-gray-400 border-solid w-full h-1 my-2"></div>

      <div className="sm:grid sm:grid-cols-2 lg:grid-cols-3">{accountEl}</div>
    </section>
  );
}
